import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

export const state = {
  // ---- ---- 페이징 정보 저장 ---- ----
  condition: {
    searchFlag: false,
    searchText: '',
    searchType: '',
    userNo: '',
    ...defaultPaging
  },

  aliveCondition: {
    andersenNo: '',
    ...defaultPaging
  },

  commentCondition: {
    andersenNo: '',
    page: 1,
    limit: 20
  },

  // ---- ---- 상세 정보 구간 ---- ----
  detail: {
    andersenNo: '',
    userNo: '',
    familyCode: '',
    deadName: '',
    churchJob: '',
    birthDate: '',
    deathDate: '',
    church: ''
  },
  aliveDetail: {
    aliveNo: '',
    andersenNo: '',
    userNo: '',
    title: '',
    contents: '',
    isActive: '',
    regDate: '',
    files: []
  },

  // ---- ---- 상세 정보 구간 종료 ---- ----
  // ---- ---- 데이터 추가 구간 ---- ----
  register: {
    step1: [
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      },
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      }
    ],
    step2: [
      {
        title: '',
        andersenNo: '',
        contents: '',
        date: '',
        whenBeforeSend: 0,
        targets: []
      }
    ],
    step3: {
      title: '',
      backgroundImageNo: '',
      frameNo: '',
      backgroundFile: '',
      userNo: ''
    }
  },

  // ---- ---- 데이터 추가 구간 종료 ---- ----
  // ---- ---- List 정보 ---- ----
  list: [],
  aliveList: [],
  commentList: [],
  // ---- ---- List 정보 종료 ---- ----

  pageInfo: { ...defaultPageInfo },

  backgroundList: [],
  frameList: [],
  anniversaryList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
